import {
  PASSIVE_SET_FILTERS,
  PASSIVE_CLEAR_FILTERS,
  PASSIVE_SET_PAGE,
  PASSIVE_SET_PAGE_SIZE,
  PASSIVE_SET_SEARCH,
  PASSIVE_SET_SORT,
  PASSIVE_FETCH_REQUEST,
  PASSIVE_FETCH_SUCCESS,
  PASSIVE_FETCH_FAILURE,
} from '../actions/actionTypes';
import { PassiveAction } from '../actions/passiveActions';
import { FiltersState, EMPTY_FILTERS } from '../../Talent/components/FiltersDrawer';
import { RawTalentRow } from '../../Talent/transformers/talentTransformer';

export interface PassiveState {
  filters: FiltersState;
  search: string;
  sort: { column: string; direction: string } | null;
  data: RawTalentRow[];
  pagination: {
    page: number;
    pageSize: number;
    total: number;
    totalPages: number;
  };
  loading: boolean;
  error: string | null;
}

const initialState: PassiveState = {
  filters: EMPTY_FILTERS,
  search: '',
  sort: null,
  data: [],
  pagination: { page: 1, pageSize: 20, total: 0, totalPages: 0 },
  loading: false,
  error: null,
};

export default function passiveReducer(
  state: PassiveState = initialState,
  action: PassiveAction,
): PassiveState {
  switch (action.type) {
    case PASSIVE_SET_FILTERS:
      return { ...state, filters: action.payload, pagination: { ...state.pagination, page: 1 } };
    case PASSIVE_CLEAR_FILTERS:
      return { ...state, filters: EMPTY_FILTERS, pagination: { ...state.pagination, page: 1 } };
    case PASSIVE_SET_SEARCH:
      return { ...state, search: action.payload, pagination: { ...state.pagination, page: 1 } };
    case PASSIVE_SET_SORT:
      return { ...state, sort: action.payload, pagination: { ...state.pagination, page: 1 } };
    case PASSIVE_SET_PAGE:
      return { ...state, pagination: { ...state.pagination, page: action.payload } };
    case PASSIVE_SET_PAGE_SIZE:
      return { ...state, pagination: { ...state.pagination, pageSize: action.payload, page: 1 } };
    case PASSIVE_FETCH_REQUEST:
      return { ...state, loading: true, error: null };
    case PASSIVE_FETCH_SUCCESS:
      return { ...state, loading: false, data: action.payload.data, pagination: action.payload.pagination };
    case PASSIVE_FETCH_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
}
